import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PUBLIC_SIGN_IN_ENABLED } from '../constants/publicAuth';

interface StartCreatingButtonProps {
  maxWidth?: string;
  maxHeight?: string;
  fontSize?: string;
  padding?: string;
  marginTop?: string;
}

const StartCreatingButton = ({
  maxWidth = '200px',
  maxHeight = '52px',
  fontSize = '16px',
  padding = '16px 32px',
  marginTop = '40px'
}: StartCreatingButtonProps) => {
  const navigate = useNavigate();
  const handleSignIn = async () => {
    navigate('/sign-in');
  };

  if (!PUBLIC_SIGN_IN_ENABLED) return null;

  return (
    <Button
      onClick={handleSignIn}
      sx={{
        maxWidth,
        maxHeight,
        fontSize,
        marginTop,
        width: '100%',
        padding,
        borderRadius: '170px',
        boxShadow: '0px -4px 50px 0px rgba(11,87,208,0.68)',
        fontWeight: 'bold',
        background: 'linear-gradient(163deg, rgb(12, 174, 207) -29.1%, rgb(88, 15, 107) 96.45%)',
        color: 'white',
        textTransform: 'none'
      }}
    >
      Start Creating
    </Button>
  );
};

export default StartCreatingButton;
